<app-card [loading]="(loading$ | async) ?? false">
  <div class="header" [formGroup]="filterForm">
    <button
      type="button"
      class="button icon-button filter-button-mobile"
      (click)="openFilterDialog()"
    >
      <app-icon name="ic_filter" />
      {{ "default.filter" | translate }}
    </button>

    <a
      class="button primary-button icon-button end"
      [routerLink]="['/', RouteConstants.routeRule, RouteConstants.routeAdd]"
    >
      <app-icon name="ic_plus" />
      {{ "rules.new" | translate }}
    </a>
  </div>

  <ng-template #filterFields>
    <div class="header filter-fields" [formGroup]="filterForm">
      <div class="filter-group">
        <app-input-wrapper [control]="filterForm.controls['searchTerm']">
          <app-icon input-wrapper-icon-start name="ic_search" />
          <input
            type="search"
            formControlName="searchTerm"
            [placeholder]="'default.search' | translate"
          />
        </app-input-wrapper>
      </div>

      <div class="filter-group">
        @for (
          isActiveOption of filterOptions.isActive;
          track isActiveOption.value;
          let i = $index
        ) {
          <app-input-wrapper [control]="filterForm.controls['isActive']">
            <input
              [id]="isActiveOption.value ?? i"
              [value]="isActiveOption.value"
              type="radio"
              formControlName="isActive"
            />
            <label [for]="isActiveOption.value ?? i">{{
              isActiveOption.label | translate
            }}</label>
          </app-input-wrapper>
        }
      </div>
    </div>
  </ng-template>

  @if (!isFilterDialogOpen) {
    <div class="filter-desktop">
      <ng-container *ngTemplateOutlet="filterFields" />
    </div>
  }

  <div class="content grid grid-cols-auto">
    @for (rule of ruleList$ | async; track rule.id) {
      <app-rule-item-card
        [rule]="rule"
        (delete)="onDeleteRule($event)"
        (changeIsActive)="onChangeIsActive($event)"
        [disabled]="!(killSwitch$ | async)"
      />
    } @empty {
      {{ "rules.empty.headline" | translate }}
    }
  </div>

  <div class="footer">
    <app-pagination
      [pageSize]="filterForm.value.pageSize"
      [totalCount]="totalCount$ | async"
      [currentPage]="filterForm.value.page"
      (pageChange)="onChangePage($event)"
      [loading]="loading$ | async"
    />
  </div>
</app-card>
